<!-- 完善信息弹层 -->
<template>
  <div class="jobsPopUps" @click.stop>
    <div class="content pa bg_fff">
      <div class="tipsTitle f_16 color_40 font_w_b">按在线职位搜索</div>
      <div class="tipsText f_14 color_60">全部在线职位</div>

      <div class="myPosition clearfix resetScrollBar" v-if="myPosition.list.length">
        <template  v-for="(item,index) in myPosition.list">
          <div class="Bitem fl" :key="String(index)">
            <div :class="['item', query.job_id === item.recruit_info.id?'current':'']" @click="clickJobs(item,index)" data-growing-container data-growing-title='搜索主页在线职位'>
              <div class="title ellipsis f_14 color_60">{{item.recruit_info.job_post}}</div>
              <div class="text f_12 color_9c afterText">
                <span v-if="item.cities">{{item.cities[0]}}</span>
                <span v-if="item.display_degree">{{item.display_degree}}</span>
                <span v-if="item.display_experience">{{item.display_experience}}</span>
                <span v-if="item.salary">{{item.salary}}</span>
              </div>
            </div>
          </div>
        </template>
      </div>

      <div class="buttons clearfix f_14 text_center">
        <div class="confirm fr cursor_p bg_current color_fff" v-if="query.job_id" @click="toSearch">确定</div>
        <div class="confirm fr cursor_p bg_cf color_fff" v-else >确定</div>
        <div class="cancel fr cursor_p bg_fff color_60" @click="updateBlockStateFun({type: 'jobsPopUpsState', value:false})">取消</div>
      </div>


    </div>
  </div>
</template>

<script>
// 所有接口
import actions from '@/actions/index'
import { mapState, mapMutations } from 'vuex'
export default {
  data(){
    return {
      query:{},
      jobType:{
        '中专':'中专,高中,大专,本科,硕士,博士,MBA',
        '高中':'高中,大专,本科,硕士,博士,MBA',
        '大专':'大专,本科,硕士,博士,MBA',
        // '专科':'专科,本科,硕士,博士,MBA',
        '本科':'本科,硕士,博士,MBA',
        '硕士':'硕士,博士,MBA',
        '博士':'博士,MBA',
        'MBA':'MBA',
      },
    }
  },
  computed:{
    ...mapState('resumeDetails',['myPosition', 'routePageName']),

  },
  created(){
    document.body.style.position = 'static'
    document.body.style.overflow = 'hidden'
  },
  beforeDestroy(){
    document.body.style.position = 'initial'
    document.body.style.overflow = 'initial'
  },
  methods:{
    ...mapMutations('block',[ 'updateBlockStateFun']),
    //【职位】点击职位
    clickJobs(item,index){
      //更新query的部分值
      let { id, job_post } = item.recruit_info;
      this.query = {
        keyword: job_post,
        city: item.cities ? item.cities[0] : '',
        education: item.display_degree ? (item.display_degree==='学历不限' ? '' : this.jobType[item.display_degree])  : '',
        workYear: item.display_experience ? (item.display_experience==='经验不限' ? '' : (item.display_experience==='1年以下' ? '应届生' : item.display_experience) )  : '',
        job_id: id,
        searchPositionIndex:index
      }
    },
    toSearch(){
      this.updateBlockStateFun({type: 'jobsPopUpsState', value:false})
      if(this.routePageName === 'talentSearch'){
        this.$emit('clickJobs', this.query)
      }else{
        this.$router.push({name:'talentSearchList', query: this.query})
      }
    },
  }

}
</script>
<style lang="scss" scoped>
  .jobsPopUps{
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 10;
    background: rgba($color: #000, $alpha: 0.4);
    .content{
      left: 50%;
      top: 50%;
      box-sizing: border-box;
      width: 624px;
      box-shadow:0px 1px 3px 0px rgba(0,0,0,0.03);
      border-radius:4px;
      padding: 32px 0;
      transform: translate(-50%, -50%);
      box-sizing: border-box;
    }
    .tipsTitle{
      line-height: 20px;
      margin-bottom: 12px;
      padding: 0 32px;
    }
    .tipsText{
      line-height: 18px;
      margin-bottom: 30px;
      padding: 0 32px;
    }
    // 按线上职位搜索
    .myPosition{
      padding: 0 32px;
      max-height: 374px;
      overflow: auto;
      -ms-overflow-style:none; /* Edge */
      .Bitem{
        width: 272px;
        margin-bottom: 16px;
        .item{
          box-sizing: border-box;
          padding: 10px 16px 0;
          border-radius:2px;
          border:1px solid #EFEFEF;
          cursor: pointer;
          height: 62px;
          &:nth-child(4n){
            margin-right: 0;
          }
          .title{
            line-height: 16px;
          }
          .text{
            line-height: 16px;
            margin-top: 10px;
            height: 16px;
            overflow: hidden;
            span{
              display: inline-block;
            }
          }
          &:hover,&.current{
            border-color: #4183FF;
            .title,.text{
              color: #4183FF;
            }
          }
        }
        &:nth-child(2n){
          float: right;
        }
      }

    }
    .buttons{
      margin-top: 24px;
      padding: 0 32px;
      .confirm{
        width: 108px;
        line-height: 34px;
        border-radius:2px;
        margin-left: 16px;
        &:hover{
          opacity: 0.8;
        }
      }
      .cancel{
        box-sizing: border-box;
        width:108px;
        height:34px;
        line-height: 32px;
        border: 1px solid #D9D9D9;
        border-radius:2px;
        &:hover{
          opacity: 0.8;
        }
      }
    }
  }
</style>
